import { useState, useContext, useEffect } from 'react';
import { motion } from "framer-motion";
import Footer from '../includes/footer-tab';
import Dropdown from '../includes/Dropdown';
import { ToastContainer, toast } from 'react-toastify';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import Preloader from './Preloader';
import { useNavigate } from 'react-router-dom';
import { AuthContext, shareApp, getSavedReferCode } from '../context/AuthContext';
import $ from 'jquery';
import { Link } from 'react-router-dom';

function Mine() {
    const [userid, setuserid] = useState('');
    // const preloader = true;
    const [preloader, setpreloader] = useState(true);
    const { isAuthenticated, logout, profile } = useContext(AuthContext);
    const navigate = useNavigate();
    if (!isAuthenticated) {
        navigate('/login')
    }
    const message = (status, text) => {
        if (status === 1) {
            toast.success(text, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else if (status === 0) {
            toast.error(text, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else if (status === 2) {
            toast.warning(text, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }
    useEffect(() => {
        profile(function (response) {
            setpreloader(false);
            if (response.status === 0) {
                message(0, response.msg);
            } else {
                setuserid(response.data[0].mobile);
            }
        });
    }, [profile])

    const handleLogout = () => {
        logout();
    };
    return (
        <>
            <Preloader status={preloader} />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <motion.div
                initial={{ translateX: -100 }}
                animate={{ translateX: 0 }}
                exit={{ translateX: 0 }}
                transition={{ duration: 0.2 }}
            >
                <div className="mine header">
                    <div className="item">
                        <div className="mine item1">
                            <div className="profile_image"></div>
                            <div>
                                <p>User: &nbsp;&nbsp; {'+91' + userid}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mine list-of-options">
                    <Dropdown icon="/icons_asset/home.png" url="/dashboard" name="Dashboard" itemclick="" menu={{}} />
                    <Dropdown icon="/icons_asset/wallet.png" url="" name="Wallet" itemclick="" menu={[{ 'name': 'Recharge (पैसा जोड़े)', 'url': '/recharge' }, { 'name': 'Withdrawal (अपना पैसा निकाले )', 'url': '/withdrawal' } ]} />
                    <Dropdown icon="/icons_asset/win_record.png" url="/history/win" name="Win History (अपना जीत देखे)" itemclick="" menu={{}} />
                    <Dropdown icon="/icons_asset/cancel_record.png" url="/history/marketcancel" name="Kabad cancel box" itemclick="" menu={{}} />
                    <Dropdown icon="/icons_asset/history.png" url="/history/market" name="Bid History (अपना खेला हुआ गेम देखे)" itemclick="" menu={{}} />
                    <Dropdown icon="/icons_asset/rate_list.png" url="/ratelist" name="Rate List" itemclick="" menu={{}} />
                    {/* <Dropdown icon="/icons_asset/rate_list.png" url="https://wa.me/+17019630397" name="Marketing Number" itemclick="" menu={{}} /> */}
                    <Dropdown icon="/icons_asset/code.png" url="/refer" name="Refer & Earn (दोस्तों को जोड़ो, बोनस पाओ)" itemclick="" menu={{}} />
                    <Dropdown icon="/icons_asset/share.png" url="#" name="Share App (जो गेम खेलता है उसे शेयर करें)" itemclick={(e) => { e.preventDefault(); shareApp(getSavedReferCode()); }} menu={{}} />
                    <div className="social-links-container">
      <div className="social-links-row">
        {/* Chat Section */}
        <Link to="https://youtube.com/@aghorimatka?si=0XRmz4bH4PBWAmbN" className="social-link-item">
          <div className="icon-wrapper chat">
            {/* Simple text replication for Chat icon */}
            <FaYoutube />
          </div>
          <p>गेम खेलना सीखे अघोरी मटका में</p>
        </Link>

        {/* Facebook Section */}
        <Link to="https://www.facebook.com/groups/4836906029659692/?ref=share&mibextid=NSMWBT" className="social-link-item">
          <div className="icon-wrapper facebook">
            <FaFacebook />
          </div>
          <p>सॉलिड गेम के लिए हमारा फेसबुक ग्रुप ज्वाइन करे</p>
        </Link>

        {/* Instagram Section */}
        <Link to="https://www.instagram.com/aghorikhaiwall?igsh=Z2Zid245b2Y1b2Vk" className="social-link-item">
          <div className="icon-wrapper instagram">
            <FaInstagram />
          </div>
          <p>इंस्टाग्राम पर फॉलो करे</p>
        </Link>
      </div>
    </div>


                    <div className="items" onClick={() => { $('.logout-modal.modal').addClass('active') }}>
                        <button className='btn-3 ripple'>{isAuthenticated ? 'Logout' : 'Login'}</button>
                    </div>
                </div>
            </motion.div>
            <section className="logout-modal modal">
                <div className="section">
                    <p>Confirm</p>
                    <p>Do you want to continue?</p>
                    <div className="btn-container">
                        <div className="action-btn">
                            <div onClick={() => { $('.logout-modal.modal').removeClass('active') }}>CANCEL</div>
                            <div onClick={handleLogout}>YES</div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer page='mine' />
        </>
    );
}

export default Mine;
